import type { PortableTextComponentProps } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'
import clsx from 'clsx'
import { useMemo, type FC } from 'react'

import { Block } from './Block'

export const RichTextBlock: FC<
  PortableTextComponentProps<PortableTextBlock>
> = ({ value, ...props }) => {
  const isLeftAligned = useMemo(() => {
    return (
      value.children?.some((child) => child.marks?.includes('alignLeft')) ??
      false
    )
  }, [value])

  const conditionalClasses = useMemo(
    () => (isLeftAligned ? ['section-rich-text-block--left-aligned'] : []),
    [isLeftAligned],
  )

  const blockStyleClass = useMemo(
    () =>
      (
        ({
          h1: ['section-rich-text-block', 'type-h1'],
          h2: ['section-rich-text-block', 'type-h2'],
          h3: ['section-rich-text-block', 'type-h3'],
          h4: ['section-rich-text-block', 'type-h4'],
          h5: ['section-rich-text-block', 'type-label'],
          normal: [
            'section-rich-text-block',
            'type-body',
            'section-rich-text-block--restricted-width',
          ],
          normalFullWidth: ['section-rich-text-block', 'type-body'],
        })[value.style || ''] || []
      )
        .concat(conditionalClasses)
        .join(' '),
    [value, conditionalClasses],
  )

  return (
    <Block value={value} {...props} className={clsx(blockStyleClass)}>
      {props.children}
    </Block>
  )
}
